/** Coerce get_asset_detail / JSON-RPC tag payloads into a sorted unique string list. */
export function normalizeAssetTags(raw: unknown): string[] {
  if (raw == null) return [];
  if (Array.isArray(raw)) {
    const out = raw
      .map((t) => (typeof t === "string" ? t.trim() : String(t).trim()))
      .filter((t) => t.length > 0);
    return [...new Set(out)].sort((a, b) => a.localeCompare(b));
  }
  return [];
}
